import * as yup from 'yup';
import { birthDateSchema } from 'shared/validators/date.validator';

// Регулярное выражение для проверки на наличие только русских и латинских букв
const nameRegex = /^[А-Яа-яA-Za-z]+$/;

export const applicationLinkValidator = yup.object().shape({
  name: yup
    .string()
    .required('Имя обязательно')
    .matches(nameRegex, 'Имя должно содержать только буквы, без пробелов, цифр и специальных символов'),
  surname: yup
    .string()
    .required('Фамилия обязательна')
    .matches(nameRegex, 'Фамилия должна содержать только буквы, без пробелов, цифр и специальных символов'),
  patronymic: yup
    .string()
    .optional()
    .matches(nameRegex, 'Отчество должно содержать только буквы, без пробелов, цифр и специальных символов')
    .nullable(),
  birthday: birthDateSchema,
  consent: yup.boolean().oneOf([true], 'Я даю согласие на обработку персональных данных обязателен'),
});
